import css from "csstype";

const rowConsistent: css.Properties = {
  backgroundColor: "#d4edda",
};

const rowInconsistent: css.Properties = {
  backgroundColor: "#f8d7da",
};

const statusLabelAccepted: css.Properties = {
  color: "#0a7c00",
};

const statusLabelRejected: css.Properties = {
  color: "#a4262c",
};

const statusLabelInline: css.Properties = {
  fontSize: "13px",
  marginRight: "10px",
};

const actionsCell: css.Properties = {
  width: "300px",
  maxWidth: "300px",
  minWidth: 0,
  verticalAlign: "top",
  boxSizing: "border-box",
};

const actionsCellLayout: css.Properties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: "4px",
  width: "100%",
  minWidth: 0,
};

const actionsTopRow: css.Properties = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  alignItems: "center",
  gap: "6px",
  minWidth: 0,
  width: "100%",
};

const actionsStack: css.Properties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: "4px",
  width: "100%",
  minWidth: 0,
};

const dialogContentWrapper: css.Properties = {
  marginTop: "12px",
};

const textarea: css.Properties = {
  width: "300px",
};

const validationError: css.Properties = {
  color: "#a4262c",
  marginTop: "8px",
};

const baselineStaleHint: css.Properties = {
  fontSize: "11px",
  color: "#805900",
  lineHeight: 1.2,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
};

const styles = {
  rowConsistent,
  rowInconsistent,
  statusLabelAccepted,
  statusLabelRejected,
  statusLabelInline,
  actionsCell,
  actionsCellLayout,
  actionsTopRow,
  actionsStack,
  dialogContentWrapper,
  textarea,
  validationError,
  baselineStaleHint,
};

export default styles;
